import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const PageLoader: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] space-y-4">
      <Loader2 className="w-10 h-10 text-primary animate-spin" />
      <p className="text-gray-400 font-mono text-sm tracking-wider animate-pulse">
        {t('loading', 'Chargement en cours...')}
      </p>
    </div>
  );
};

